<mat-dialog-content>
  <div class="row">
    <div class="col-12">
      <span class="secondary-details mr-2">{{
        'shipment.shipment.shipmentInformation' | translate
      }}</span>
      <div class="row">
        <div class="col-auto pe-0">
          <span *ngIf="shipmentData?.shipmentID"
            >{{ 'shipment.shipment.shipmentId' | translate }} : {{ shipmentData.shipmentID }}</span
          >
        </div>
        <div class="col-2 me-0 pe-0" [ngClass]="{ 'col-3': this.pieceLevelLabelPrint }">
          <span *ngIf="shipmentData?.status">
            {{ 'shipment.shipment.status' | translate }}: {{ shipmentData.status }}
          </span>
        </div>

        <!--  -->
        <div class="col-auto" style="top: 3px">
          <div
            class="col ps-0"
            *ngIf="
              (shipmentData.productCode === 'A' || shipmentData.productCode === 'B') &&
              this.looseBbx &&
              mawbList.length > 0 &&
              !(shipmentData.status == 'Manifest Failed' || shipmentData.status == 'Manifested')
            ">
            <span class="float-start" for=""
              >{{ 'shipment.shipment.motherSId' | translate }} :</span
            >
            <mat-form-field
              class="float-start ps-1 pe-1"
              style="font-size: 4px; bottom: 10px"
              appearance="none">
              <mat-select
                disableRipple
                [(ngModel)]="selectedMawbId"
                [disabled]="lbbxLinkedCheck()"
                class="form-control"
                (selectionChange)="linkShipments($event.value)">
                <mat-option *ngFor="let item of mawbList" [value]="item.mawb">
                  {{ item.mawb }}
                </mat-option>
              </mat-select>
              <div class="col-auto m-0 p-0" style="color: red; font-size: 1rem">
                <small *ngIf="checkMawbSelected()"
                  >*{{ 'shipment.shipment.selectMotherSId' | translate }}</small
                >
              </div>
            </mat-form-field>
            <button
              style="position: relative; bottom: 4px"
              *ngIf="lbbxLinkedCheck()"
              (click)="linkShipments('')"
              class="secondary-btn me-2"
              type="button">
              {{ 'shipment.shipment.delink' | translate }}
            </button>
          </div>
          <div
            class="col ps-0"
            *ngIf="
              this.looseBbx &&
              this.mawbId !== undefined &&
              this.mawbId !== '' &&
              (shipmentData.status == 'Manifest Failed' || shipmentData.status == 'Manifested')
            ">
            <span class="float-start" for="">{{ 'shipment.shipment.mawbId' | translate }} :</span>
            <span class="float-start">{{ mawbId }}</span>
          </div>
        </div>
        <!--  -->
        <div class="col-auto m-0 p-0" style="color: red; font-size: 1rem">
          <small *ngIf="isShipmentValid() && this.shipmentManagement.touched"
            >*{{ 'shipment.shipment.shipmentValidationErrorLabel' | translate }}.</small
          >
        </div>
        <div class="col">
          <div class="row text-end">
            <div class="col">
              <button
                *ngIf="
                  ((!userExportedInvoice && showLineItem) || showLineItem) &&
                  !(shipmentData.productCode === 'A' || shipmentData.productCode === 'B') &&
                  shipmentStatus === 'Manifested' &&
                  shipmentData?.commercial_invoice_found
                "
                class="secondary-btn me-2"
                (click)="printInvoice(shipmentData?.shipmentID)">
                {{ 'maw.mawList.printInvoice' | translate }}
              </button>
              <button
                type="button"
                *ngIf="
                  ((!userExportedInvoice && showLineItem) || showLineItem) &&
                  shipmentStatus === 'Manifested' &&
                  shipmentData?.commercial_invoice_files_count > 0
                "
                class="secondary-btn me-2"
                matTooltip="{{ 'maw.mawList.viewDocuments' | translate }}"
                (click)="openUploadInvoices(shipmentData?.shipmentID, shipmentStatus)">
                {{ 'maw.mawList.viewDocuments' | translate }}
              </button>
              <button
                *ngIf="this.pieceLevelLabelPrint == false && disablePrintViewLabel()"
                (click)="viewLabel()"
                class="secondary-btn me-2"
                type="button">
                {{ 'shipment.shipment.viewLabel' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="responseLoaded" id="shipmentForm" [formGroup]="shipmentManagement">
        <mat-tab-group
          mat-align-tabs="start"
          #shipmentTabs
          (selectedTabChange)="onStatusTabChange($event)">
          <mat-tab label="{{ 'shipment.shipment.shipment' | translate }}">
            <div class="row scroll-details">
              <app-shipper
                class="col-md-6"
                formGroupName="shipperDetails"
                [shipmentStatus]="shipmentStatus"
                [countryCode]="shipperCountryCodeChange"
                [isShipPostalValidated]="isShipPostalValidated"
                (myShipUpdatedStatus)="showStatusfromShip($event)"
                [shipmentForm]="shipmentManagement"></app-shipper>

              <app-receiver
                class="col-md-6"
                formGroupName="receiverDetails"
                [shipmentStatus]="shipmentStatus"
                [countryCode]="receiverCountryCodeChange"
                [isRecPostalValidated]="isRecPostalValidated"
                [receiverAddress]="receiverCompleteDetails"
                (myRecUpdatedStatus)="showStatusfromRec($event)"
                [shipmentForm]="shipmentManagement"></app-receiver>

              <app-shipment-info
                [DGContentIDValues]="dgContentIds"
                [DGPackageData]="DGPackageData"
                [customDescriptions]="customDescriptions"
                [currencyValues]="currencyValues"
                [DGContentFromConfig]="DGContentFromConfig"
                [shipmentForm]="shipmentManagement"
                (validateMod7)="showStatusforShipID($event)"
                [shipmentDeclaredValue]="shipmentDeclaredValue"
                [productNameValues]="productNameValues"
                [customsDeclarableValue]="customsDeclarableValue"></app-shipment-info>
            </div>
          </mat-tab>
          <!-- <mat-tab label="Invoice Details" *ngIf="!userExportedInvoice">
            <app-invoice
              *ngIf="!userExportedInvoice"
              formGroupName="invoiceDetails"
              [shipmentForm]="shipmentManagement"></app-invoice>
          </mat-tab> -->
          <mat-tab
            label="{{ 'shipment.shipment.lineItemInformation' | translate }}"
            *ngIf="(!userExportedInvoice && showLineItem) || showLineItem">
            <div class="row scroll-details">
              <app-line-item
                *ngIf="(!userExportedInvoice && showLineItem) || showLineItem"
                formGroupName="invoiceDetails"
                (rowDeleted)="updatePieces($event)"
                [shipmentData]="shipmentData"
                [decimalValue]="decimalValue"
                [currencyValues]="currencyValues"
                [shipmentForm]="shipmentManagement"
                [additionalPartiesListFromShipment]="additionalPartiesListFromShipment"
                [isLineTab]="tabIndex === 1"></app-line-item>
            </div>
          </mat-tab>
          <mat-tab label="{{ 'shipment.shipment.pieceInformation' | translate }}">
            <div class="row">
              <app-piece
                (rowDeleted)="updatePieces($event)"
                [shipmentData]="shipmentData"
                [pieceLevelLabelPrint]="pieceLevelLabelPrint"
                [shipmentForm]="shipmentManagement"
                (updatedForm)="updateForm($event)"
                (findDuplicatePiecRef)="disableUpdatePiecRef($event)"></app-piece>
            </div>
          </mat-tab>
          <mat-tab label="{{ 'shipment.billingDetails.billingDetails' | translate }}">
            <div class="row scroll-details">
              <app-billing-details
                [shipmentData]="shipmentData"
                [shipmentForm]="shipmentManagement"></app-billing-details>
            </div>
          </mat-tab>
          <mat-tab
            label="{{ 'shipment.shipment.shipmentLogs' | translate }}"
            *ngIf="!(this.data?.action == 'create')">
            <div class="row">
              <app-shipment-history
                [shipmentData]="shipmentData"
                (updateShipmentEvent)="getShipment()"></app-shipment-history>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="primary-btn me-2 text-center" mat-dialog-close="" type="button">
    {{ 'shipment.shipment.close' | translate }}
  </button>
  <button
    class="primary-btn me-2 text-center"
    *ngIf="shipmentData.status == 'Manifest Failed'"
    (click)="remanifestBaby()"
    type="button">
    {{ 'shipment.shipment.reManifest' | translate }}
  </button>
  <button
    class="primary-btn me-2 text-center"
    *ngIf="this.data?.action == 'create' || shipmentData.status == 'Draft'"
    (click)="updateShipment('draft')"
    type="button">
    {{ 'shipment.shipment.save' | translate }}
  </button>
  <button
    *ngIf="
      this.id &&
      this.shipmentData.status !== 'Draft' &&
      this.shipmentData.status !== 'Manifest Failed' &&
      this.shipmentData.status !== 'Manifested'
    "
    [disabled]="!disableSave()"
    (click)="updateShipment('update')"
    class="primary-btn me-2 text-center"
    type="button">
    <span>{{ 'shipment.shipment.save' | translate }}</span>
  </button>

  <button
    *ngIf="
      !this.id || (this.id && this.shipmentData.status == 'Draft' && this.shipmentManagement.valid)
    "
    [disabled]="!disableCreate()"
    (click)="updateShipment('create')"
    class="primary-btn me-2 text-center"
    type="button">
    {{ 'shipment.shipment.create' | translate }}
  </button>
  <ng-container *ngIf="!this.pieceLevelLabelPrint">
    <button
      [disabled]="checkMawbSelected()"
      *ngIf="disableCreateLabel()"
      (click)="generateLabel()"
      class="primary-btn me-2"
      type="button">
      {{ 'shipment.shipment.print' | translate }}
    </button>
    <!--Generate label-->
    <button
      *ngIf="this.id && this.shipmentData.status !== 'Draft' && disableUpdate()"
      [disabled]="!disableUpdate()"
      (click)="updateShipment('print')"
      class="primary-btn me-2 text-center"
      type="button">
      {{ 'shipment.shipment.print' | translate }}</button
    ><!--Update and print-->
    <button
      *ngIf="disablePrintButton() && !disableUpdate()"
      (click)="printLabel()"
      class="primary-btn me-2"
      type="button">
      {{ 'shipment.shipment.print' | translate }}</button
    ><!--Fetch label-->
  </ng-container>
</mat-dialog-actions>
